import React from 'react';
import styles from './ActionsInLeft.module.scss';
import { LabeledToggleButton } from 'components/common';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_TIMELINE_STORE, EDITOR_MONITOR_STORE } from 'store';
import { ActionsInLeftProps } from './types';

const ActionsInLeft = (props: ActionsInLeftProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      timelineSyncedToMonitor,
      switchTimelineSyncingToMonitor
    },
    [EDITOR_MONITOR_STORE]: {
      showIaPictures,
      switchShowAiPictures
    }
  } = props;

  return (
    <div className={styles.container}>
      <LabeledToggleButton
        switchedOn={timelineSyncedToMonitor}
        onClick={switchTimelineSyncingToMonitor}
        size='mini'
        label='synced to timeline'
      />

      <LabeledToggleButton
        switchedOn={showIaPictures}
        onClick={switchShowAiPictures}
        size='mini'
        label='show product/person picture'
        style={{ marginLeft: 20 }}
      />
    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE, EDITOR_MONITOR_STORE)(observer(ActionsInLeft));
